export const SET_LIST_FRAUD_TYPES = "SET_LIST_FRAUD_TYPES";
export const SET_LIST_FRAUD_CONFIG = "SET_LIST_FRAUD_CONFIG";
export const SET_IS_LOADING_FRAUD_CONFIG = "SET_IS_LOADING_FRAUD_CONFIG";
export const SET_FRAUD_CONFIG_STATUS = "SET_FRAUD_CONFIG_STATUS";
export const SET_DETAIL_FRAUD_CONFIG = "SET_DETAIL_FRAUD_CONFIG";
export const SET_EDIT_FRAUD_CONFIG = "SET_EDIT_FRAUD_CONFIG";
